exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".confirm-heading-btn[data-v-6ec7399a]{margin-right:40px}", "", {"version":3,"sources":["/home/circleci/repo/app/components/postEditor/parts/ConfirmHeading.vue"],"names":[],"mappings":"AAuHA,sCACE,iBAAA,CAAA","file":"ConfirmHeading.vue?vue&type=style&index=0&id=6ec7399a&scoped=true&lang=sass&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.confirm-heading-btn\n  margin-right: 40px\n"],"sourceRoot":""}]);

// exports
